import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="34408" id="hero" className="relative w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="h-full w-full bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609985/img/bodywerks-watermark.png')] bg-cover bg-center bg-no-repeat opacity-5" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-primary/95" />

      {}
      <div className="relative z-20 mx-auto flex min-h-[600px] max-w-7xl flex-col items-center justify-center px-6 py-[120px] text-center">
        <div ref={ref} className={`flex max-w-3xl flex-col items-center gap-8 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <h1 className="sr-only">Free Online Posture Assessment</h1>

          {}
          <h2 className="font-serif text-4xl font-bold tracking-tight text-primary-foreground drop-shadow-md sm:text-5xl md:text-[72px]">
            Is Your Posture Affecting Your Health?
          </h2>

          {}
          <p className="max-w-2xl font-sans text-lg leading-[1.6] text-accent sm:text-[18px]">
            Take our quick 2-minute assessment to discover how spinal alignment influences your energy, mobility, and long-term wellness.
          </p>

          {}
          <Button asChild className="h-auto rounded-lg bg-accent px-8 py-4 font-sans text-base font-semibold text-accent-foreground shadow-lg transition-all hover:scale-105 hover:bg-accent/90 hover:shadow-accent/50">
            <Link to="/BookAppointmentPage">Start Your Assessment</Link>
          </Button>
        </div>
      </div>
    </section>;
}